import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { premiumStoresListQueries } from '@/services/premiumStores/premiumStores.queries';
import { PremiumStores } from '@/services/premiumStores/premiumStores.types';

export const usePremiumStorePreview = (clubId?: string, holdId?: string) => {
  const { data, isLoading } = useQuery({
    ...premiumStoresListQueries.detail('P', {
      clubId: clubId || '',
      holdId: holdId || '',
    }),
  });

  return {
    getPendingPremiumStoreDetails: (data?.data as PremiumStores) || {},
    isLoading,
  };
};
